var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 11,
    viewBox: "0 0 7 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.31649 1.06041L0.845328 3.61177C0.660239 3.80288 0.660928 4.11198 0.846943 4.3022C1.03294 4.4924 1.33377 4.49167 1.51888 4.30057L3.17767 2.58788V9.59408C3.17767 9.86371 3.39039 10.0823 3.65281 10.0823C3.91523 10.0823 4.12795 9.86371 4.12795 9.59408V2.5879L5.78674 4.30054C5.97185 4.49165 6.27268 4.49238 6.45868 4.30218C6.64472 4.11195 6.64536 3.80283 6.46029 3.61175L3.98959 1.06083C3.80386 0.869628 3.5016 0.869799 3.31649 1.06041Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpArrow);
export default __webpack_public_path__ + "static/media/UpArrow.79dbb904b923bf895ea06ca8bc63db32.svg";
export { ForwardRef as ReactComponent };